// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__u25UK","loader":"Loader_loader__DfVO2"};